import React from "react";

function SapValueRealization() {
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb5">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            SAP Value Realization
          </h4>
        </div>
      </div>

      {/* Body Section Start */}
      <div className="container py-5">
        <section className="wow fadeInUp" data-wow-delay="0.2s">
          <div className="row align-items-center g-5">
            {/* Image Section */}
            <div className="col-lg-6 col-md-12">
              <img
                src="assets/img/valueRealizationsmall.jpg"
                alt="SAP Value Realization"
                className="img-fluid rounded-4 shadow-lg"
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* Text Section */}
            <div className="col-lg-6 col-md-12">
              <div className="section-title">
                <h2 className="fw-bold text-primary mb-3">
                  Maximize Return on Investment
                </h2>
                <p>
                  Our <strong>Value Realization Service</strong> ensures that your
                  investments in SAP deliver the expected benefits and value to
                  your organization. This is crucial for maximizing the return on
                  IT investments and fostering overall business success.
                </p>
                <p>Key benefits associated with our value realization services are listed below:</p>
                <ul className="list-unstyled ms-3">
                  <li> Optimized Investments</li>
                  <li> Alignment with Business Objectives</li>
                  <li> Improved Decision Making</li>
                  <li> Enhanced Operational Efficiency</li>
                  <li> Measurable Outcomes</li>
                  <li> Increased Stakeholder Satisfaction</li>
                  <li> Demonstrated Accountability</li>
                </ul>
                <p className="mt-3">
                  In summary, IT value realization is a strategic approach that
                  ensures your IT investments contribute positively to your
                  organization's objectives. By focusing on alignment, efficiency,
                  and measurable outcomes, you can derive maximum value from your
                  IT initiatives and foster long-term success.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Mobile Image Adjustment */}
      <style>
        {`
          @media (max-width: 768px) {
            img[alt="SAP Value Realization"] {
              max-height: 350px !important;
            }
          }
        `}
      </style>
    </>
  );
}

export default SapValueRealization;
